import React from 'react'
import * as S from './styles'

import NewModuleTag from '@/components/LandingPage/NewModuleTag'

import { useTranslation } from 'react-i18next'

const DetailsSubItem = ({ index, data }) => {
  const { t } = useTranslation()

  return (
    data && (
      <S.DetailsSubItemContainer id={`section-subitem-${index}`}>
        <div className="flexbox v-centered mb-4">
          <h3>{t(data.title)}</h3>
          {data.newUntil && <NewModuleTag expDate={data.newUntil} />}
        </div>
        <p>{t(data.text)}</p>
        {data.customComponent && <data.customComponent />}
        <div className="flexbox v-centered h-centered pb-5 pt-4">
          {data.image && (
            <img src={data.image} width={1280} height={720} alt="" />
          )}
          {data.video && (
            <video preload="auto" playsInline loop muted autoPlay>
              <source type="video/mp4" src={data.video} />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </S.DetailsSubItemContainer>
    )
  )
}

export default DetailsSubItem
